import universal from 'react-universal-component';

export default universal(() => import('./Login'));



// WEBPACK FOOTER //
// ./src/app/views/Login/index.js